import styled from "styled-components";

export const ReminderPopupStack = styled.div`
    position: fixed;
    top: 92px;
    right: 1rem;
    z-index: 70;
    display: grid;
    gap: 0.75rem;
    width: min(320px, calc(100vw - 2rem));
    pointer-events: none;
`;

export const ReminderPopupCard = styled.div`
    pointer-events: auto;
    border-radius: var(--calendar-radius-card);
    border: 1px solid var(--calendar-border);
    background: var(--calendar-shell);
    box-shadow: var(--calendar-shadow);
    padding: 0.95rem 1rem;
    display: grid;
    gap: 0.55rem;
`;

export const ReminderPopupTop = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.75rem;
`;

export const ReminderPopupTitle = styled.div`
    font-size: 0.95rem;
    font-weight: 800;
    color: var(--calendar-text);
`;

export const ReminderPopupCaption = styled.div`
    font-size: 0.85rem;
    color: var(--calendar-text-muted);
    line-height: 1.4;
`;

export const ReminderPopupDismiss = styled.button`
    border: none;
    background: transparent;
    color: var(--calendar-text-soft);
    width: 22px;
    height: 22px;
    border-radius: var(--calendar-radius-control);
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    cursor: pointer;
`;
